import type { CreateFileValidatorParams, FileValidationResult } from './types';
import { createMimeTypeValidator, createSizeValidator } from './validators';

export const createFileValidator = ({
  allowedMimeTypes,
  maxFileSize,
}: CreateFileValidatorParams) => {
  const validators = [
    createMimeTypeValidator(allowedMimeTypes),
    createSizeValidator(maxFileSize),
  ];

  return (file: File): FileValidationResult[] =>
    validators.map((validator) => validator(file));
};
